import(/* webpackMode: "eager" */ "D:\\dev\\danchudoba\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\danchudoba\\components\\layout\\ScrollProgressIndicator.tsx");
